import TopNav from '@/components/scaffold/top-nav/TopNav';
import { usePayoutCheckoutData } from '@/stores/payout-checkout-store';
import { Box, Button, Container, Flex } from '@chakra-ui/react';
import { PayoutBatchStatus } from '@fluenceur/types';
import { Logo } from '@fluenceur/ui';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { PayoutCheckoutSteps, payoutStepPaths } from './PayoutCheckoutSteps';

interface PayoutCheckoutLayoutProps {
  children?: React.ReactNode;
}

const PayoutCheckoutLayout: React.FC<PayoutCheckoutLayoutProps> = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { payout } = usePayoutCheckoutData();

  useEffect(() => {
    if (payout?.status === PayoutBatchStatus.COMPLETED) {
      navigate('/payments/commissions?tab=payouts');
    }
  }, [payout, navigate]);

  const handleExit = () => {
    navigate('/payments/commissions?tab=payouts');
  };

  const currentPath = location.pathname.split('/').pop();
  const currentStepIndex = payoutStepPaths.findIndex(
    (step: { path: string }) => step.path === currentPath
  );
  const activeStep = currentStepIndex >= 0 ? currentStepIndex : 0;
  const isProcessingStep = currentPath === 'processing';

  const rightSection = (
    <Button variant="ghost" onClick={handleExit} size="sm">
      {isProcessingStep ? t('payouts.checkout.actions.exit') : t('payouts.checkout.actions.cancel')}
    </Button>
  );

  return (
    <Box minH="100vh" bg="softCream">
      <TopNav
        leftSection={<Logo height="21px" />}
        rightSection={rightSection}
        bg="white"
        position="sticky"
        top={0}
        zIndex={100}
      />
      <Flex alignItems="center" justifyContent="center" px={6} py={8}>
        <PayoutCheckoutSteps activeStep={activeStep} />
      </Flex>
      <Container maxW="6xl" minH="400px">
        <Outlet />
      </Container>
    </Box>
  );
};

export default PayoutCheckoutLayout;
